import './SearchPanel.scss'

import { useEffect, useState } from "react";
import { search } from "../../../server/requests";
import { useRouter } from "../../../hooks/router";

import RowList from "../../Row_List/RowList";
import FilterButtons from "./FilterButtons";
import ErrorMessage from "../../AlertMessage/AlertMessage";

import { translateWord } from "../../Util/util";

let time_out_search

export default function SearchPanel({ isGuest}) {
    const router = useRouter()

    const [searchVal, setSearchVal] = useState('')
    const [listSearchPanel, setListSearchPanel] = useState([
        { id: 1, title: '', type: 'movie', name: 'Movies', content: [] },
        { id: 2, title: '', type: 'tv-shows', name: "Tv show", content: [] },
        { id: 3, title: '', type: 'live_tv', name: 'Live tv', content: [] },
    ])
    const [typeSearch, setTypeSearch] = useState('all')
    const [visibleArray, setVisibleArray] = useState([])
    const [errorSearch, setErrorSearch] = useState({ show: 'false' })

    const [loadingShow, setLoadingShow] = useState(false)

    useEffect(() => {
        let time_out_search

        if (router.query.q) setSearchVal(router.query.q)
        else router.push(`/search?type=${typeSearch}`)


        time_out_search = setTimeout(() => {
            let val = router.query.q ? router.query.q.trim() : router.query.q
            get_search_list(val)
        }, 500)
        setTypeSearch(router.query.type)

        return () => clearTimeout(time_out_search)
    }, [searchVal, router.query.q])


    const changeSearchValue = (e) => {
        setSearchVal(e.target.value)
        router.push(`${router.pathname}?type=${typeSearch}&q=${e.target.value}`)
    }

    const get_search_list = (val) => {
        setLoadingShow(true)
        search({ search: val ? val : '' }, data => {
            setLoadingShow(false)
            let newArr = listSearchPanel
            Object.keys(data).map((key, index) => {

                if (key !== 'casts') {

                    let array
                    if (key === 'channels')
                        array = data[key][0].channels;
                    else array = data[key][0].content;

                    newArr[index].content = []

                    for (let j = 0; j < array.length; j++) {
                        newArr[index].content.push({ ...array[j] })
                    }

                }
            })
            setListSearchPanel([...newArr])
            const x = listSearchPanel.find(k => k.type === typeSearch)
            if (x) {
                setVisibleArray([{ ...x }])
            } else {
                setVisibleArray(listSearchPanel)
            }
            setErrorSearch({ show: 'false' })
        }, err => {
            setErrorSearch({
                text: err,
                show: 'true',
            })
        })
    }


    const callBackFilterType = (type) => {
        setTypeSearch(type)
        if (!searchVal.length) router.push(`/search?type=${type}`)
        else router.push(`/search?type=${type}&q=${searchVal}`)
        setLoadingShow(true)
        // localStorage.setItem('type', type ? type : 'All')
        const x = listSearchPanel.find(k => k.type === type)
        if (x) {
            setVisibleArray([{ ...x }])
        } else {
            setVisibleArray(listSearchPanel)
        }

        clearTimeout(time_out_search)
        time_out_search = setTimeout(() => {
            setLoadingShow(false)
        }, 500)
    }
    return (
        <>
            <div className="container">
                <ErrorMessage type={'error'} show={errorSearch.show} text={errorSearch.text} />
                <div className="main_search_panel">

                    <FilterButtons
                        setTypeSearch={setTypeSearch}
                        callBackFilterType={callBackFilterType}
                    />

                    <div className="input_search">
                        <input type="text" value={searchVal} onInput={changeSearchValue} placeholder={translateWord('Search')} />

                        <h2>{searchVal.trim().length ? <>{translateWord('Results for')}:<span>"{searchVal}"</span></> : null}</h2>

                    </div>
                    <div className="list_search_panel">
                        {loadingShow ?
                            <div className="parent_loading_search">
                                <div className="loader"></div>
                            </div>
                            : null}

                        {visibleArray.map((elem, index) => {
                            return elem.content.length ? <RowList
                                key={elem.id}
                                title={elem.name}
                                type={elem.type}
                                row={elem}
                                array={elem.content}
                                rowIndex={index}
                                isGuest={isGuest}

                            /> :
                                null

                        })}

                    </div>
                </div>
            </div>
        </>


    )
}